import { FC, useState } from 'react';
import ViewWeekSharp from '@mui/icons-material/ViewWeekSharp';
import { Box, Checkbox, ClickAwayListener, FormControlLabel, IconButton, Popper } from '@mui/material';
import React from 'react';
import { gridColumnProperties } from 'src/types/gridColumnProperties';
import '../../theme/partials/ColumnSelector.css';

interface Props {
  columns: gridColumnProperties[];
  onChange: (fieldName: string) => void;
}

const ColumnSelector: FC<React.PropsWithChildren<Props>> = ({ columns, onChange }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState<boolean>(false);

  const handleClick = (e) => {
    setOpen(!open);
    setAnchorEl(e.target);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box sx={{ pl: 2, textAlign: 'right' }} className="column-selector">
      <Box>
        <IconButton size="small" onClick={handleClick}>
          <ViewWeekSharp sx={{ width: '0.8em', color: '#042312' }}></ViewWeekSharp>
        </IconButton>
      </Box>
      <Box className="column-selector__popper-container">
        {open ? <div className="styled-dropdown-triangle"></div> : <></>}
        <Popper
          style={{ zIndex: 1000, maxHeight: '300px', overflow: 'auto' }}
          anchorEl={anchorEl}
          open={open}
          className="filter-box"
          placement="bottom-start"
          modifiers={[
            {
              name: 'flip',
              options: {
                enabled: false,
                fallbackPlacements: [],
              },
            },
          ]}
        >
          <ClickAwayListener onClickAway={handleClose}>
            <div className="text-dropdown-list">
              {columns &&
                columns.map(
                  (column, idx) =>
                    column.toggleDisplay && (
                      <Box key={idx} sx={{ px: '11px' }}>
                        <FormControlLabel
                          control={<Checkbox size="small" checked={column.display} />}
                          onClick={() => {
                            onChange(column.field);
                          }}
                          label={column.title}
                        />
                      </Box>
                    )
                )}
            </div>
          </ClickAwayListener>
        </Popper>
      </Box>
    </Box>
  );
};

export default ColumnSelector;
